import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Navbar from "../Navbar/Main";
import Footer from "../Footer/Main";
import LRsidebar from "./lrsidebar";
import { Pagination } from "../DataTable";
import ShareToolsBar from "../Publications/ShareToolsBar";
import "../Publications/PublicationsMain.css";
import "./banking.css";

export const Financialmarkets = () => {
    const [clicked, setClicked] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCategory, setSelectedCategory] = useState("laws");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const ITEMS_PER_PAGE = 10;

  useEffect(() => {
    axios
      .get(`/fm_laws`)
      .then((res) => {
        setDocuments(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setError("Failed to load documents.");
        setLoading(false);
      });
  }, []);

  const categories = [
    { key: "laws", label: "Laws", icon: "⚖️" },
    { key: "regulations", label: "Regulations", icon: "🔨" },
    { key: "directives", label: "Directives", icon: "📢" },
    { key: "guidelines", label: "Guidelines", icon: "📖" },
  ];

  // Count per category
  const counts = useMemo(() => {
    return documents.reduce(
      (acc, d) => {
        const type = d.type || "laws";
        acc[type] = (acc[type] || 0) + 1;
        return acc;
      },
      { laws: 0, regulations: 0, directives: 0, guidelines: 0 }
    );
  }, [documents]);

  // Filter & paginate
  const filteredDocs = useMemo(
    () => documents.filter((d) => (d.type || "laws") === selectedCategory),
    [documents, selectedCategory]
  );

  const paginatedDocs = useMemo(() => {
    const start = (currentPage - 1) * ITEMS_PER_PAGE;
    return filteredDocs.slice(start, start + ITEMS_PER_PAGE);
  }, [filteredDocs, currentPage]);

  if (loading) return <p className="text-center">Loading documents…</p>;
  if (error) return <p className="text-center text-danger">{error}</p>;

  return (
    <>
      <Navbar />
      <nav className="publications-bnr-breadcrumb-bar" aria-label="Breadcrumb"><div className="container"><ol className="publications-bnr-breadcrumb"><li><Link to="/">Home</Link></li><li className="publications-bnr-breadcrumb__sep" aria-hidden="true">›</li><li><Link to="/lawsandregulations">Laws and Regulations</Link></li><li className="publications-bnr-breadcrumb__sep" aria-hidden="true">›</li><li aria-current="page">Financial Markets</li></ol></div></nav>
      <section className="publications-bnr-hero" aria-labelledby="laws-detail-title">
        <div className="publications-bnr-hero__bg" aria-hidden="true" />
        <div className="publications-bnr-hero__overlay" aria-hidden="true" />
        <div className="container">
          <div className="publications-bnr-hero__card">
            <div className="d-flex flex-wrap align-items-start justify-content-between gap-3">
              <div className="flex-grow-1" style={{ minWidth: "min(100%, 16rem)" }}>
                <h1 id="laws-detail-title" className="publications-bnr-hero__title">
                  Financial Markets
                </h1>
                <span className="publications-bnr-hero__title-line" aria-hidden="true" />
                <p className="small publications-bnr-hero__tagline mt-2 mb-0">
                  Legal instruments for Rwanda&apos;s financial sector
                </p>
              </div>
              <div className="flex-shrink-0">
                <ShareToolsBar pageTitle="Financial Markets - Laws and Regulations" />
              </div>
            </div>
            <div className="publications-bnr-hero__lead">
              <p>
                The National Bank of Rwanda is the Supervisor and Regulator of Domestic Financial Market. A
                financial market is a market in which people and entities can trade financial securities,
                commodities, and other fungible items of value at low transaction costs and at prices that
                reflect supply and demand. Securities include stocks and bonds, and commodities include precious
                metals or agricultural goods.
              </p>
              <p>
                Therefore, the Central Bank, in order to ensure the promotion, soundness and stability of this
                market, has established a legal and regulatory framework. This section on the Central Bank
                website contains all relevant legal instruments pertaining to the Financial Market System in
                Rwanda.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="service-details banking-ecb pt-50 pb-100">
        <div className="container">
          <div className="row row-gutter-y-50 contact-info-one">
            <div className="col-lg-8">
              
                                <div className="service-details__content">
                                <div className="row row-gutter-y-30">
                                        <div className="col-md-12">
               <p className="service-details__text">The following are Laws and Regulations related to Financial Markets</p>

              {/* Category Tabs */}
              <div className="faq-tabs mb-4">
                {categories.map(({ key, label, icon }) => (
                  <button
                    key={key}
                    onClick={() => {
                      setSelectedCategory(key);
                      setCurrentPage(1);
                      setClicked(null);
                    }}
                    className={`faq-tab-button position-relative ${
                      selectedCategory === key ? "active" : ""
                    }`}
                  >
                    <span className="me-2">{icon}</span>
                    {label}
                    <span className="faq-count-circle">{counts[key] || 0}</span>
                  </button>
                ))}
              </div>

             {/* Doc Accordions for Selected Category */}
                    {paginatedDocs.length === 0 ? (
                        <p className="text-center">No documents found.</p>
                    ) : (
                        paginatedDocs.map((d, index) => (
                            <div
                                key={d.name || index}
                                className={`accrodion-grp service-details__accrodion mb-3 ${clicked === `${d.name}-${index}` ? "active" : ""}`}
                                data-grp-name="service-details__accrodion-1"
                            >
                                <div className="accrodion wow fadeInUp" data-wow-delay="0ms">
                                    <div
                                        className="accrodion-title"
                                        onClick={() => setClicked(clicked === `${d.name}-${index}` ? null : `${d.name}-${index}`)}
                                    >
                                        <h4>{d.name}</h4>
                                        <span className="accrodion-icon"></span>
                                    </div>
                                    {clicked === `${d.name}-${index}` && (
                                        <div className="accrodion-content">
                                             <div className="inner_doc" >
                                                <p>{d.summary}</p>
                                                    <Link to={d.file} target="_blank">Download/View <i className="fa fa-file-pdf"></i></Link>
                                             </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))
                    )}
              {/* Pagination */}
              <div className="d-flex justify-content-center mt-4">
                <Pagination
                  total={filteredDocs.length}
                  itemsPerPage={ITEMS_PER_PAGE}
                  currentPage={currentPage}
                  onPageChange={setCurrentPage}
                />
              </div>
            </div>
              </div>
            </div>
         </div>
            <div className="col-lg-4">
              <LRsidebar />
            </div>
          </div>
        </div>
      </section>

      <Link
        to="#"
        data-target="html"
        className="scroll-to-target scroll-to-top"
      >
        <i className="fa fa-angle-up"></i>
      </Link>

      <Footer />
    </>
  );
};
